import Cart from "@/assets/images/3d-icons/cart.png";
import Gift from "@/assets/images/3d-icons/gift.png";

export const ROTATE_INTERVAL_MS = 4000;
export const SCROLL_DURATION_MS = 400;

export const words = [
  {
    title: "Book Faster & Easier",
    description: "Sign in for a streamlined experience.",
    image: Cart,
  },
  {
    title: "Get your $15 referral code",
    description: "Log in to share and earn $15.",
    image: Gift,
  },
];
